import APIService from '@/services/APIService.js'; 

export default {
  getAll() {
    return APIService.apiCall().get('/ferramentas/get-all');
  },
  getById(id) {
    return APIService.apiCall().get(`/ferramentas/get-by-id/${id}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/ferramentas/salvar/${postData.id}`, JSON.stringify(postData));
  },
  atualizarStatus(id, novoStatus) {
    return APIService.apiCall().get(`/ferramentas/alteraStatus/${id}/${novoStatus}`);
  }
};